import { pickKey } from './members';
import { formatDisplayDate, formatDisplayDateRange } from '../utils/displayDate';

// Multi-Event project suggestions: EPS projects whose Load-In date is within
// a few days of the first selected project's Load-In date.

export const SUGGESTION_WINDOW_DAYS = 7;

/** Whole days from a to b ('YYYY-MM-DD…'), or null when either is missing. */
function dayDiff(aISO, bISO) {
  const parse = (iso) => {
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(iso || ''));
    return m ? Date.UTC(+m[1], +m[2] - 1, +m[3]) : null;
  };
  const a = parse(aISO);
  const b = parse(bISO);
  if (a === null || b === null) return null;
  return Math.round((b - a) / 86400000);
}

/** "Oct 28, 2026" for a Load-In ISO date. */
export function formatLoadInDate(iso) {
  return formatDisplayDate(iso);
}

/** "Nov 3" for a Load-In ISO date. */
export function formatShortDate(iso) {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(iso || ''));
  if (!m) return '';
  return new Date(Date.UTC(+m[1], +m[2] - 1, +m[3]))
    .toLocaleDateString('en-US', { month: 'short', day: 'numeric', timeZone: 'UTC' });
}

/**
 * Candidates with a Load-In within ±days of anchorLoadInISO (inclusive),
 * leaving out selected projects and cancelled proposals. Ineligible rows are
 * kept so they show with their reason; nothing here changes eligibility.
 * Ordered closest Load-In first (earlier date, then name, on ties), with
 * ineligible rows after the ones that can be added.
 */
export function projectsNearLoadIn(candidates, anchorLoadInISO, selectedIds, days = SUGGESTION_WINDOW_DAYS) {
  if (!anchorLoadInISO) return [];
  const selected = new Set(selectedIds || []);
  return (candidates || [])
    .map((c) => ({ c, d: dayDiff(anchorLoadInISO, c.loadInISO) }))
    .filter(({ c, d }) => d !== null && Math.abs(d) <= days &&
      !selected.has(pickKey(c)) &&
      !/cancel/i.test(c.proposalStatus || ''))
    .sort((x, y) => (x.c.available === y.c.available ? 0 : x.c.available ? -1 : 1) ||
      Math.abs(x.d) - Math.abs(y.d) || x.d - y.d || String(x.c.title).localeCompare(String(y.c.title)))
    .map(({ c }) => c);
}

/** "Nov 4–13, 2026", "Nov 28–Dec 3, 2026", "Dec 28, 2026–Jan 3, 2027", "Nov 5, 2026". */
export function formatShortRange(startISO, endISO) {
  if (!formatDisplayDate(startISO)) return '';
  return formatDisplayDateRange(startISO, endISO);
}
